import {ForwardingBatchItemType} from "@twigsby/client-data/lib/Types/ForwardingBatchTypes";
import {MailFile} from "@twigsby/client-data/lib/Types/MailFileTypes";
import {
    Badge,
    ColourSolid,
    ItemRow,
    ItemRowSize,
    Pill,
    PillSize,
    Placement,
    StackVertical,
    useLayout
} from "@twigsby/frontend-framework";
import {FormatLocaleDateTime} from "@twigsby/helpers";
import {memo} from "react";
import {MailItemNoThumbnail, MailItemThumbnail, MailPartTypeEnum} from "../Mail/MailItemThumbnails";

export const ForwardingBatchContents = (props: MailFile) => {
    return (
        props.userFileThumbnails && props.userFileThumbnails.length > 0 ? (
            <div className={props.userFileThumbnails.length === 1 ? '' : `thumbnail-stack`}>
                {props.userFileThumbnails.map((file, index) =>
                    <MailItemThumbnail key={`forwardingBatchContentsThumb${file.fileName}${index}`} {...file} />
                )}
            </div>
        ) : (
            <MailItemNoThumbnail mailType={MailPartTypeEnum['Mail-Envelopes']}/>
        )
    )
}

const ForwardingBatchItem = memo((props: ForwardingBatchItemType) => {
    const { isTiny, isMedium, isLarge, isXL } = useLayout();

    const statusColour = props.statusDescription === 'Forwarded' ? ColourSolid.Success : props.statusDescription === 'Pending' ? ColourSolid.Warning : ColourSolid.Alert;

    return (
        <ItemRow
            size={ItemRowSize.Large}
            highlighted={statusColour === ColourSolid.Alert}
            muted={statusColour !== ColourSolid.Alert}
            extraProps={{
                'draggable': false,
            }}
            actionLink={{ url: `/mail/forwarding-batches/${props.batchId}`}}
        >
            <div style={{ position: 'relative'}}>
                {props.files.map((file, index) =>
                    <ForwardingBatchContents {...file} />
                )}

                <Badge placement={Placement.BottomRight} value={props.itemsInBatch} />
            </div>

            <div className='flex-row flex-gap-sm mail-item-reference'>
                <StackVertical>
                    <span className='mail-item-tracking-id'>
                        {props.batchIdNo}
                    </span>
                    {isTiny && (
                        <Pill content={props.statusDescription} colour={statusColour} size={PillSize.Small} />
                    )}
                </StackVertical>
            </div>
            {!isTiny && (
                <div className={'flex-row'}>
                    <Pill content={props.statusDescription} colour={statusColour} size={PillSize.Small} />
                </div>
            )}
            <div>
                {props.lastChanged ? FormatLocaleDateTime(props.lastChanged) : ''}
            </div>
            {isMedium && (
                <div className='mail-item-pages'>{props.forwardingAddress.formatted}</div>
            )}
            {isLarge && (
                <div className='mail-item-tags'>{props.postageOption}</div>
            )}
            {isXL && (
                <div className='mail-item-tracking-numbers'>
                    {props.trackingNumber && (
                        <div>{props.trackingNumber}</div>
                    )}
                </div>
            )}
        </ItemRow>
    );
});

export default ForwardingBatchItem;
